import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const locales = [
  {
    code: "tr",
    name: "Türkçe",
    flagSrc: "/assets/flags/tr.svg",
    dir: "ltr"
  },
  {
    code: "en",
    name: "English",
    flagSrc: "/assets/flags/en.svg",
    dir: "ltr"
  },
  {
    code: "ru",
    name: "Русский",
    flagSrc: "/assets/flags/ru.svg",
    dir: "ltr"
  },
  {
    code: "ar",
    name: "العربية",
    flagSrc: "/assets/flags/ar.svg",
    dir: "rtl"
  },
];

const LocaleSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLocale, setSelectedLocale] = useState(
    locales.find(locale => locale.code === i18n.language) || locales[0]
  );

  const handleSelect = (locale) => {
    setSelectedLocale(locale);
    setIsOpen(false);
    i18n.changeLanguage(locale.code);
    document.documentElement.dir = locale.dir;
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-x-2 text-sm font-medium text-gray-600 hover:text-gray-900"
      >
        <img
          src={selectedLocale.flagSrc}
          alt={`${selectedLocale.name} flag`}
          className="w-5 h-5"
        />
        <span className="hidden md:block">{selectedLocale.name}</span>
        <svg
          className={`h-5 w-5 flex-none text-gray-400 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg py-2 w-48 z-50">
          <div className="p-2">
            {locales.map((locale) => (
              <button
                key={locale.code}
                onClick={() => handleSelect(locale)}
                className={`flex items-center w-full gap-x-3 rounded-lg py-2 px-3 text-sm leading-6 text-gray-900 hover:bg-gray-50 ${
                  selectedLocale.code === locale.code ? "bg-gray-50" : ""
                }`}
              >
                <img
                  src={locale.flagSrc}
                  alt={`${locale.name} flag`}
                  className="w-5 h-5"
                />
                <span>{locale.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LocaleSelector;
